import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LoadingUbsHealthPromotionModal } from 'src/app/shared/components/loading-ubs-health-promotion-modal/loading-ubs-health-promotion-modal.component';
import { JourneyStageEnum } from 'src/app/shared/enum/journey-stage.enum';
import { UbsScreenEnum } from 'src/app/shared/enum/ubs-screen.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { StadiometerMeasurementService } from 'src/app/shared/services/API/ubs-health-promotion/ubs-stadiometer-measurer.service';
import { PatientData, UBSConfigData, UtilsUBSService } from '../../utils-ubs.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { listMockHeight, listMockWeight } from 'src/app/ubs-health-promotion/mock-data';

@Component({
  selector: 'app-measurement-guidelines-scale',
  templateUrl: './measurement-guidelines-scale.component.html',
  styleUrls: ['./measurement-guidelines-scale.component.css']
})
export class MeasurementGuidelinesScaleComponent implements OnInit, OnDestroy {

  private title: string = 'measurement-guidelines-scale';

  constructor(
    private titleService: Title,
    private utilsUBSService: UtilsUBSService,
    private dialog: MatDialog,
    private router: Router,
    private alertService: AlertService,
    private stadiometerMeasurementService: StadiometerMeasurementService,
    @Inject(LOCALE_ID) private locale: string
  ) {
    this.titleService.setTitle($localize`${this.title}`);
  }
  private thisScreen: UbsScreenEnum = UbsScreenEnum.MeasurementGuidelinesScale;
  public isError = false;
  public audio = new Audio();
  private uBSConfigData: UBSConfigData = new UBSConfigData();
  public idUbsScreen = UbsScreenEnum.MeasurementGuidelinesScale;
  public journeyStage: number = JourneyStageEnum.MedirPeso;
  public isLoading: boolean = false;
  public interval: any;
  public seconds = 0;
  public patient: PatientData = new PatientData();
  public connectionCount: number = 0;
  public startInterval: NodeJS.Timeout | null = null;
  public stadiometerMeasurement: any;
  public readInterval: NodeJS.Timeout | null = null;
  public urlBaseDevice: string = '';
  public pageIndex: number = 0;
  public mockTimeout: NodeJS.Timeout | null = null;
  private readTime: number = 0;
  private inRequest: boolean = false;

  ngOnInit(): void {
    this.uBSConfigData = this.utilsUBSService.getUBSData();
    if (!this.uBSConfigData || !this.uBSConfigData.listUBSStruct) {
      this.router.navigate(['/ubs/erro']);
    }
    this.pageIndex = this.uBSConfigData.listUBSStruct.findIndex(x => x.idUBSScreen == this.idUbsScreen);

    if (this.pageIndex == -1) {
      this.router.navigate(['/ubs/erro']);
    }

    this.urlBaseDevice = this.uBSConfigData.ipDevice;
    //this.urlBaseDevice = "192.168.0.46";
    this.activateDataStream();
  }

  ngOnDestroy() {
    this.audio.pause();
    if (this.startInterval)
      clearInterval(this.startInterval);
    if (this.readInterval)
      clearInterval(this.readInterval);
    if (this.mockTimeout)
      clearTimeout(this.mockTimeout);
  }

  activateDataStream() {
    if (this.uBSConfigData.isClientTest) {
      let $this = this;
      this.mockTimeout = setTimeout(() => {
        let randomHeight = listMockHeight[Math.floor(Math.random() * listMockHeight.length)]
        randomHeight = listMockHeight[0]
        let randomWeight = listMockWeight[Math.floor(Math.random() * listMockWeight.length)]
        randomWeight = listMockWeight[0]
        $this.patient = $this.utilsUBSService.getPatientData();
        if (!$this.patient) {
          $this.patient = new PatientData();
        }
        $this.patient.weight = randomWeight;
        $this.patient.height = randomHeight;
        $this.utilsUBSService.createPatientData($this.patient);
        $this.saveLastPage();
        $this.router.navigate([`ubs${$this.uBSConfigData.listUBSStruct[$this.pageIndex + 1].screenUrl}`]);
        clearTimeout($this.mockTimeout!);
      }, 5000);

      return;
    }
    this.connectionCount += 1;

    if (this.connectionCount > 2) {
      this.router.navigate(['/ubs/erro']);
      return;
    }
    this.stadiometerMeasurementService.start(this.urlBaseDevice).subscribe((response) => {
      if (response.isError) {
        this.isLoading = false;
        return;
      }
      this.isLoading = false;
      this.startRead();

    },
      (error) => {
        this.isLoading = false;
        // this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  readDataStream() {
    if (this.inRequest) return;
    this.inRequest = true;
    this.stadiometerMeasurementService.read(this.urlBaseDevice).subscribe((response) => {
      this.inRequest = false;
      if (response.isError || !response.running) {
        this.isLoading = false;
        if (this.readInterval)
          clearInterval(this.readInterval);
        this.retryConnection();
        return;
      }

      if (response.message) {
        this.stadiometerMeasurement = response.message.split("/");
        this.patient = this.utilsUBSService.getPatientData();
        if (!this.patient) {
          this.patient = new PatientData();
        }
        this.patient.weight = this.stadiometerMeasurement[0];
        this.patient.height = this.stadiometerMeasurement[1];
        this.utilsUBSService.createPatientData(this.patient);
        if (this.readInterval)
          clearInterval(this.readInterval);
        this.deactivateDataStream();
        this.isLoading = false;
        this.saveLastPage();
        this.router.navigate([`ubs${this.uBSConfigData.listUBSStruct[this.pageIndex + 1].screenUrl}`]);
      }

    },
      (error) => {
        this.isLoading = false;
        this.alertService.show('Erro esperado', error, AlertType.error);
      });
  }

  deactivateDataStream() {
    this.stadiometerMeasurementService.stop(this.urlBaseDevice).subscribe((response) => {
      if (response.isError) {
        this.isLoading = false;
        this.router.navigate(['/ubs/erro']);
        return;
      }
      this.isLoading = false;

    },
      (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      });
  }

  startRead() {
    let $this = this;
    this.readInterval = setInterval(() => {
      $this.readTime += 1;
      $this.readDataStream();
      if ($this.readTime >= 6000) {
        $this.isError = true;
        if ($this.readInterval)
          clearInterval($this.readInterval);
      }
    }, 100);
  }

  OpenLoadingModal() {
    const dialogRef = this.dialog.open(LoadingUbsHealthPromotionModal, {
      width: '854px',
      height: '452px',
      panelClass: 'loading-ubs-health-promotion-modal',
      disableClose: true,
    });
  }

  endFlowMeasurer() {
    this.audio.pause();
    let lastScreen = this.uBSConfigData.listUBSStruct[0];
    if (!lastScreen) {
      this.router.navigate(['/ubs/erro']);
    }
    this.router.navigate(['/ubs' + lastScreen.screenUrl]);
  }

  retryConnection() {
    this.activateDataStream();
  }

  retryRead() {
    this.readDataStream();
  }

  retryMeasurer() {
    this.isError = false;
    this.startRead();
  }

  goBack() {
    this.audio.pause();
    let screen = this.uBSConfigData.listUBSStruct.findIndex(x => x.idUBSScreen == this.thisScreen.valueOf());
    if (screen == -1) {
      this.router.navigate(['/ubs/erro']);
    }
    let lastScreen = this.uBSConfigData.listUBSStruct[screen - 1];
    if (!lastScreen) {
      this.router.navigate(['/ubs/erro']);
    }

    let visitedPages = this.utilsUBSService.getListVisitidePages();
    let lastPage = visitedPages.pop()
    this.utilsUBSService.updateListVisitidePages(visitedPages);

    this.router.navigate([lastPage]);
  }

  playAudio() {
    this.audio.src = `../../../assets/audio/${environment.locale}/guidelines-scale.mp3`;
    this.audio.load();
    this.audio.play();
  }

  saveLastPage() {
    let visitedPages = this.utilsUBSService.getListVisitidePages();
    if (!visitedPages)
      visitedPages = [];
    visitedPages.push(this.router.url);
    this.utilsUBSService.updateListVisitidePages(visitedPages);
  }
}